import {Inject, Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {plainToClass} from 'class-transformer';
import {Observable} from 'rxjs/Observable';

import {Content} from 'shared/models/contents/content';
import {ContentType} from 'shared/models/contents/content-type';
import {ContentTypeFactoryService} from 'shared/contents/services/content-type-factory.service';
import {ContentsOverviewHttpRepository} from '../repositories/contents-overview.repository.http';
import {IContentsOverviewRepository} from '../repositories/contents-overview.repository.interface';

@Injectable()
export class ContentsOverviewService {

  constructor(@Inject('IContentsOverviewRepository') private contentsOverviewRepository: ContentsOverviewHttpRepository) { }

  public getContents(): Observable<Array<Content>> {
    return this.contentsOverviewRepository.getContents();
  }

  public deleteContent(id: string): Observable<void> {
    return this.contentsOverviewRepository.deleteContent(id);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/contents/contents-overview/services/contents-overview.service.ts